import React, { Component } from 'react';
import axios from 'axios';
import FooterLinksImages from '../atoms/FooterLinksImages.jsx'
import FooterLinksTexts from '../atoms/FooterLinksTexts.jsx'

class Footer extends Component {
    constructor(props) {
        super(props)

        this.state = {
            dataLinksFooter: []
        }
    }

        // PETITION FROM API 
    componentDidMount() {
        axios.get("https://raw.githubusercontent.com/eliud-cesar/apis-portfolio/master/redes-footer.json")
            .then(resp => {
                this.setState({
                    dataLinksFooter: resp.data
                })
            })
    }

    render() {
        const { dataLinksFooter } = this.state;
	const styleMarginZero = { marginTop: '0px', marginBottom: '0px' }
        return (
            <footer className="container-footer">
                <p style={styleMarginZero} className="copyrigth-footer" >&copy; Derechos reservados</p>

                {/* COMPONENT FORM LINK TEXTS */}
                { 
                    dataLinksFooter.map(u => {
                            return( 
                                < FooterLinksTexts
                                    LinkDiscord={u.LinkDiscord}
                                    LinkInstagram={u.LinkInstagram}
                                    LinkTelegram= {u.LinkTelegram}
                                />
                            )
                    } )
                }

                {/* COMPONENT FORM LINK IMAGES */}
                {
                    dataLinksFooter.map(u => {
                        return(
                            < FooterLinksImages
                            LinkDiscord={u.LinkDiscord}
                            LinkInstagram={u.LinkInstagram}
                            LinkTelegram= {u.LinkTelegram}
                            />
                        )
                    })
                }

                <p style={styleMarginZero} className="username-footer" >eliud_cesar</p>
            </footer>
        )
    }
}


export default Footer;
